<template>
  <div id="positionStatistical">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'positionStatistical'
}
</script>




// WEBPACK FOOTER //
// src/views/exhibition/booth/statistical/PositionStatistical.vue